import api from '../token';

export const AlterArmazem = async (dados) => {
  try {
    const response = await api.post('/alterArmazem', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};



